var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('main',[_c('Hero'),_c('Overview'),_c('Accomplishments'),_c('Appointments')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }